export const magGroup = {
  siteName: "mag",
  senderName: "Grupo Mag",
  logo: "/static/warbox_logo.png",
  name: "Grupo Mag",
  api: {
    production: "https://api.warbox.io/api/v1",
    staging: "https://staging.api.warbox.io/api/v1",
    development: "http://localhost:5000/api/v1",
  },
  client: "mag-group",
};
